module.exports = __webpack_public_path__ + "img/team6.1481623e.jpg";